














































import { Component, Vue } from 'vue-property-decorator';

import {
  ResponseCodeEnum,
  DataTableRequest,
  TireStoringContract,
} from '@/models';

import { tireStoringContractService, toastService} from '@/services';

import { DataTableSetting, FieldEnum, ActionEnum } from '@/components/shared';
import DataTable from '@/components/shared/table/DataTable.vue';
import QrcodeReader from '@/components/shared/qrcode/QrcodeReader.vue';

@Component({
  components: {
    DataTable,
    QrcodeReader,
  },
})
export default class CheckTireContract extends Vue {
  private searchText: string = '';
  private showQrcodeReader: boolean = true;
  private tableFields = [
    {
      key: 'slipNo',
      label: 'view.check-tire-contract.label.contract_number',
      type: FieldEnum.FIELD_TEXT,
      sortable: true,
    },
    {
      key: 'customer.name',
      label: 'view.check-tire-contract.label.fullname',
      type: FieldEnum.FIELD_TEXT,
      sortable: true,
    },
    {
      key: 'countOfTire',
      label: 'view.check-tire-contract.label.count_of_tire',
      type: FieldEnum.FIELD_TEXT,
      sortable: false,
    },
  ];
  private getItems: Function = new Function();
  private tableSetting: DataTableSetting = new DataTableSetting();

  private created() {
    this.getItems = (request: DataTableRequest) => {
      return tireStoringContractService
        .getContractByListSlipNo(request)
        .then((res) => {
          if (res.data.items && res.data.totalRows) {
            this.tableSetting.totalRows = res.data.totalRows;
            return res.data.items || [];
          }
        });
    };
    this.tableSetting = DataTableSetting.init(
      'slipNo',
      'desc',
      this.tableFields,
      this.getItems,
      false,
      true,
    );
  }

  private scanBarCode() {
    this.showQrcodeReader = true;
  }

  private onDecode(result: string) {
    this.showQrcodeReader = false;
    if (result) {
      this.searchText = result;
      this.tableSetting.filter = result;
    }
  }

  private inspectionCompleted() {
    const items = this.tableSetting.selected;
    tireStoringContractService.inspectionContractComplete(items)
    .then((res) => {
      if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
        toastService.successMessage('view.check-tire-contract.msg.inspection_contract_complete_success');
        this.tableSetting.filter = '';
        this.showQrcodeReader = true;
      } else {
        toastService.errorMessage('view.check-tire-contract.msg.inspection_contract_complete_fail');
      }
    });
  }
}
